import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import SingedInLinks from './SingedInLinks';
import SingedOutLinks from './SingedOutLinks';
import {connect} from 'react-redux' ;
import M from 'materialize-css/dist/js/materialize.min.js'

class Navbar extends Component{

    componentDidMount=()=>{
        let sidenav = document.querySelector('#mobile-demo')
        M.Sidenav.init(sidenav , {})
        
    }
    // to hide the sidenav when clicked 
     handleonClickHide=()=>{
         //console.log("i m clicked")
         let click = document.querySelector('#mobile-demo')
         click.style.display = 'none'
        }
        // to show the sidenav once it is hidden
        handleonClickShow=()=>{
            //console.log("menu clicked")
            let click = document.querySelector('#mobile-demo')
            click.style.display = 'block'

        }
    render(){
        const {auth , profile} = this.props
        const link = auth.uid ? <SingedInLinks profile = {profile}/> :<SingedOutLinks/> // ternerary operator to decide if the user is logedin or log out
    return(
        <div>
        <nav className="nav-wrapper  grey darken-4">
          <div className="container">
          <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons" onClick ={this.handleonClickShow}>menu</i></a>                              
                <Link to = '/' className = "brand-logo">PlanMaker</Link>
                <ul class="right hide-on-med-and-down">
                {link}
                </ul>
            </div>
        </nav>
        {/*adding sidenav to the app */}
        
        
        <ul id="mobile-demo" class="sidenav">
        <div>
        
           <li onClick={this.handleonClickHide}><a >{link}</a></li>
           </div>
            </ul>
        
    
   

        </div>
        
    )
}
}
const mapStatetoProps=(state)=>{
    // console.log(state)
    return{
        auth : state.firebase.auth,
        profile : state.firebase.profile

    }
}
export default connect(mapStatetoProps)(Navbar)